import { TemporaryDataType } from '../temporary-data-table/useTemporaryDataState'

export const unmountWellHierarchy = (data: TemporaryDataType): TemporaryDataType => {
    const keys = Object.keys(data)
        .map(key => [getEntityTypeFromKey(key)])
        .flat() as Array<keyof TemporaryDataType>

    return Object.entries(data).reduce((acc, [key, entities]) => {
        const type = getEntityTypeFromKey(key)

        return {
            ...acc,
            [type]: removeEntity(keys, entities)
        }
    }, {} as TemporaryDataType)
}

export const removeEntity = (keys: Array<keyof TemporaryDataType>, data: Entity): Entity => {
    return data?.map(entity => {
        const entityCopy = { ...entity }

        keys?.forEach(k => {
            if (Object.hasOwn(entityCopy, k)) {
                delete entityCopy[k]
            }
        })

        return entityCopy
    })
}

export const getEntityTypeFromKey = (key: string): string => {
    return key.includes('=>') ? key.split('=>')[0] : key
}
